import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    item: {
      backgroundColor: theme.palette.grey[200],
      borderRadius: '2px',
      padding: '5px',
      marginRight: '5px',
      marginLeft: 0,
      marginBottom: '5px',
      width: 'max-content',
    },
  }),
);
